import React from 'react';
import Grid2 from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import CustomTypography from '@ui-components/Typography/CustomTypography';

interface NoDataMessageProps {
  message: string;
}

const NoDataMessage: React.FC<NoDataMessageProps> = ({ message }) => (
  <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 4 }} className="button-width">
    <Box className="text-align-center no-consults-data">
      <CustomTypography
        variant="body2"
        color="textDisabled"
        id="noAcceptedConsults"
      >
        {message}
      </CustomTypography>
    </Box>
  </Grid2>
);

export default NoDataMessage;
